import { useModal } from "@circle-react/components/Layout/ModalManagerProvider";
import { QuickPostV3Modal } from "@circle-react/components/QuickPostV3";
import { EditPostV3Modal } from "@circle-react/components/QuickPostV3/EditPostModal";

export const useQuickPostModal = () => useModal(QuickPostV3Modal);

export const useEditPostModal = () => useModal(EditPostV3Modal);
